/**
 * Artist help system — route → topic map.
 * Scoped to the routes an Artist actually uses (see app-routing + artists.routes).
 */
import { RouteHelpMapping } from '../help.types';

export const artistRouteHelpMap: RouteHelpMapping[] = [
  // Dashboard & onboarding
  { route: '/ds-dashboard', topic: 'dashboard' },
  { route: '/dashboard', topic: 'dashboard' },
  { route: '/artist-onboarding-checklist', topic: 'getting-started' },

  // Artworks
  { route: '/artists/artworks', topic: 'artworks/overview' },
  { route: '/artists/artworks/create', topic: 'artworks/creating' },
  { route: '/artists/artworks/:artworkId', topic: 'artworks/managing' },

  // Catalogue attributes
  { route: '/artists/product-series', topic: 'catalogue/attributes' },
  { route: '/artists/product-material', topic: 'catalogue/attributes' },
  { route: '/artists/product-glazes', topic: 'catalogue/attributes' },
  { route: '/artists/art-wotk-categories', topic: 'catalogue/attributes' },

  // Portfolios & sharing
  { route: '/artists/portfolio', topic: 'portfolios/overview' },

  // Connections & consignments
  { route: '/artists/connected-galleries', topic: 'connections/overview' },
  { route: '/view-consignments', topic: 'consignments/overview' },
  { route: '/artists/add-consignment', topic: 'consignments/creating' },
  { route: '/artists/consignments/:consignmentId/view', topic: 'consignments/managing' },
  { route: '/artists/product-requests', topic: 'consignments/product-requests' },
  { route: '/view-proposals', topic: 'consignments/proposals' },

  // Selling channels
  { route: '/sync-products', topic: 'selling/store-sync' },
  { route: '/social-media', topic: 'marketing/social' },

  // Account & messaging
  { route: '/edit-profile', topic: 'account/profile' },
  { route: '/inbox', topic: 'messaging/inbox' },

  // Fallback (must be last)
  { route: '*', topic: 'getting-started' },
];
